"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeGaussianBlurGLFilter extends _ShapeBaseGLFilter.default {
  constructor(direction) {
    const fsSource = `
        precision highp float;

        uniform sampler2D t_tex;
        uniform vec2 screenSize;
        varying highp vec2 v_uv;

        uniform float expos [40]; 	// dependent storing the exponentials
        uniform int radius;                // dependent specifying the radius of the kernel... derived from sigma
        uniform float direction;

        void main()
        {
            vec2 pos = gl_FragCoord.xy * screenSize;
            vec4 val = expos[0] * texture2D(t_tex, pos);
            vec2 dir = vec2(direction,1.0-direction) * screenSize;

            vec2 offset = float(1) * dir;
            val += expos[1] * (texture2D(t_tex, pos-offset) + texture2D(t_tex, pos+offset));
            offset = float(2) * dir;
            val += expos[2] * (texture2D(t_tex, pos-offset) + texture2D(t_tex, pos+offset));
            offset = float(3) * dir;
            val += expos[3] * (texture2D(t_tex, pos-offset) + texture2D(t_tex, pos+offset));
            offset = float(4) * dir;
            val += expos[4] * (texture2D(t_tex, pos-offset) + texture2D(t_tex, pos+offset));

            gl_FragColor = val;
        }
        `;
    super(fsSource);
    this.direction = direction;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.direction = gl.getUniformLocation(program, 'direction');
    uniformLocations.radius = gl.getUniformLocation(program, 'radius');
    uniformLocations.expos = gl.getUniformLocation(program, 'expos[0]');
    return uniformLocations;
  }

  willDraw(gl) {
    super.willDraw(gl);
    gl.uniform1f(this.uniformLocations.direction, this.direction);
    const maxR = 5;
    gl.uniform1i(this.uniformLocations.radius, maxR);
    const fac = -1.0 / (maxR * maxR);
    var sum = 1.0;
    var expos = new Array(40);
    expos[0] = 1.0;
    var i;

    for (i = 1; i < maxR; i++) {
      var v = Math.exp(i * i * fac);
      expos[i] = v;
      sum = sum + 2.0 * v;
    }

    for (i = 0; i < maxR; i++) {
      expos[i] = expos[i] / sum;
    }

    gl.uniform1fv(this.uniformLocations.expos, expos);
  }

}

exports.default = ShapeGaussianBlurGLFilter;